import Vue from "vue";
import axios from "./axios";
import Store from "@/store/store";

export default {
  init() {
    axios.interceptors.request.use(config => {
      const token = Store.getters["auth/getRgExternalToken"];
      Vue.$log.debug("onRequest =", config);
      Vue.$log.debug("RG External Token = ", token);
      config.headers["X-RADARGRID-API-TOKEN"] = token;
      return config;
    });

    axios.interceptors.response.use(
      response => {
        Vue.$log.debug("onResponse =", response.data);
        return Promise.resolve({
          status: true,
          data: response.data,
        });
      },
      error => {
        Vue.$log.error("onResponse =", error);
        return Promise.resolve({
          status: false,
          code: error.response.status,
          message: error.response.data.message,
          data: error.response.data.validation_results,
        });
      }
    );
  },
};
